/* eslint-disable no-unused-vars */
import axios from 'utils/axios/modules/password'
import { useState, useCallback } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import * as yup from 'yup'

function usePasswordHook() {
  const { token } = useParams()
  const history = useHistory()

  const [isSendingMail, setIsSendingMail] = useState(false)
  const [isResettingPassword, setIsResettingPassword] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [errors, setErrors] = useState([])

  const sendmailSchema = () =>
    yup.object().shape({
      tanakaId: yup
        .string()
        .matches(/^[a-zA-Z0-9!?@._+-]*$/, { message: '半角英数で入力してください' })
        .required('項目が未入力です'),
    })

  const resetSchema = () =>
    yup.object().shape({
      password: yup
        .string()
        .matches(/^[a-zA-Z0-9-_.@!?+]{8,30}$/, { message: 'パスワードは8文字以上30文字以下の半角英数をご入力ください' })
        .required('項目が未入力です')
        .specialCharacter('', 'パスワードは8文字以上30文字以下の半角英数をご入力ください'),
    })

  const sendMail = async (tanakaId) => {
    setIsSendingMail(true)

    return await axios
      .sendResetPasswordMail(tanakaId)
      .then((response) => {
        setIsSuccess(true)

        return response.data
      })
      .catch((errorMessages) => {
        setErrors(errorMessages)

        return Promise.reject(errorMessages)
      })
      .finally(() => {
        setIsSendingMail(false)
      })
  }

  const resetPassword = async (token, password) => {
    setIsResettingPassword(true)

    return await axios
      .resetPassword(token, password)
      .then((response) => {
        setIsSuccess(true)

        return response.data
      })
      .catch((errorMessages) => {
        setErrors(errorMessages)

        return Promise.reject(errorMessages)
      })
      .finally(() => {
        setIsResettingPassword(false)
      })
  }

  const execSendMail = useCallback(async (tanakaId) => {
    return await sendMail(tanakaId)
  }, [])

  const execResetPassword = useCallback(async (token, password) => {
    return await resetPassword(token, password)
  }, [])

  return {
    token,
    errors,
    setErrors,
    sendmailSchema,
    resetSchema,
    execSendMail,
    execResetPassword,
    isSendingMail,
    isResettingPassword,
    isSuccess,
    history,
  }
}

export default usePasswordHook
